import { Component, OnInit, ViewChild, EventEmitter } from '@angular/core';
import { TylerMatTableDataSource } from '../../../shared-components/angular-material/extended.class';
import { SpecialAdditionalAttendance, AttendanceSchools } from '../../../shared-components/student/attendance.model';
import { AriaDirective } from '../../../shared-components/directives/aria.directive';
import { MatSort } from '@angular/material/sort';
import { StudentService } from '../../../shared-components/student/student.service';
import { YearService } from '../../../shared-components/year/year.service';

@Component({
  selector: 'by-special-additional',
  templateUrl: './by-special-additional.component.html'
})
export class BySpecialAdditionalComponent implements OnInit {

  studentSpecialAttendance: SpecialAdditionalAttendance[] = [];
  specialAdditionalAttendanceSchools: AttendanceSchools[] = [];
  columnsToDisplaySpecialAdditional = ['Date', 'MinutesAttended', 'MinutesPossible', 'ReasonCode', 'Comment'];
  @ViewChild(MatSort) sort: MatSort;
  isBusy = true;
  specialAdditionalAttendanceAngularMatData = new TylerMatTableDataSource();
  clearFilterEvent = new EventEmitter<any>();
  constructor(
    private studentService: StudentService,
    private yearService: YearService,
  ) { }

  ngOnInit() {
    this.getSpecialAttendance();
  }

  getSpecialAttendance() {
    this.isBusy = true;
    this.studentService.getSpecialAttendance(this.studentService.selectedStudent.Id, this.yearService.student360Year.Id).subscribe(data => {
      this.studentSpecialAttendance = data;
      this.getSpecialAttendanceSchools();
      if (this.studentSpecialAttendance.length == 0) {
        this.isBusy = false;
      }
    });
  }

  getSpecialAttendanceSchools() {
    for (const att of this.studentSpecialAttendance) {
      if (this.specialAdditionalAttendanceSchools.filter(o => o.SiteId == att.SiteId).length == 0) {
        const school: AttendanceSchools = {
          SiteId: att.SiteId,
          SiteName: att.SiteName,
          PrimarySchool: att.PrimarySchool
        };
        this.specialAdditionalAttendanceSchools.push(school);
      }
    }
  }


  getSpecialAttendanceDataSource(siteId: number): TylerMatTableDataSource {
    this.specialAdditionalAttendanceAngularMatData = new TylerMatTableDataSource();
    this.specialAdditionalAttendanceAngularMatData.data = this.studentSpecialAttendance.filter(o => o.SiteId == siteId);
    this.specialAdditionalAttendanceAngularMatData.sort = this.sort;
    if (this.specialAdditionalAttendanceAngularMatData.data.length > 0) {
      this.isBusy = true;
    }
    else { this.isBusy = false; }
    return this.specialAdditionalAttendanceAngularMatData;
  }

  getSpecialAdditionalAriaRow(row: SpecialAdditionalAttendance): string {
    const colList: string[] = ['Date', 'MinutesAttended', 'MinutesPossible', 'ReasonCode', 'Comment'];

    const dataList: string[] = [row.Date.toString(),
    row.MinutesAttended.toString(),
    row.MinutesPossible.toString(),
    row.ReasonCode,
    row.Comment];

    return AriaDirective.concatAriaStrings(colList, dataList);
  }

}
